import { render } from "./AppFeedback.vue?vue&type=template&id=45418a1c&scoped=true"
import script from "./AppFeedback.vue?vue&type=script&lang=js"
export * from "./AppFeedback.vue?vue&type=script&lang=js"

import "./AppFeedback.vue?vue&type=style&index=0&id=45418a1c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45418a1c"]])

export default __exports__